module.exports = __webpack_public_path__ + "img/sinister-six.f7bddb99.svg";